import React from 'react'

import LKGrid from 'shared/LKGrid'
import LKModal from 'shared/LKModal'

import translate from '../../../translator'
import config from './DLConfig'

import container from './container'

class OfficerAssistant extends React.Component {
  getContextMenu = ({
    node: {
      data: { ManagerID },
    },
  }) =>
    this.props.base.IsArrested !== 1
      ? [
          {
            name: translate('cmd_del_curr_assistant'),
            icon: 'delete',
            action: () => this.props.openConfirmation(ManagerID),
            disabled: this.props.loading,
            permissionKey: 'LOAN_DEL_OFFICER',
          },
        ]
      : []

  render() {
    const { instanceName, data, loading } = this.props

    return (
      <>
        <LKModal.Confirmation
          name="DeleteLoanOfficerAssistantConfirmation"
          onConfirm={this.props.deleteAssistant}
          loading={loading}
        />
        <LKGrid
          instanceName={instanceName}
          rowData={data}
          getContextMenuItems={this.getContextMenu}
          onRowSelected={this.handleRowSelection}
          {...config}
        />
      </>
    )
  }
}

export default container(OfficerAssistant)
